export const shouldDisplayContract = ({
  isTempwork,
  platformClient,
}: {
  isTempwork: boolean;
  platformClient: 'LEVELWORKS' | 'AETHON' | 'HOLLANDWORX';
}): boolean => !(platformClient === 'LEVELWORKS' && isTempwork);
